// Mirror a value into the URL query string (without navigating) so the
// current view can be shared or restored later. Also called after router
// navigations, which push a bare pathname and would otherwise wipe the
// mirrored params.
export function syncQueryParam(key: string, value: unknown): void {
  if (typeof window === 'undefined') return;
  const url = new URL(window.location.href);
  if (value == null || value === '') {
    if (!url.searchParams.has(key)) return;
    url.searchParams.delete(key);
  } else {
    if (url.searchParams.get(key) === String(value)) return;
    url.searchParams.set(key, String(value));
  }
  // Keep React Router's history state intact by re-using the current entry.
  window.history.replaceState(window.history.state, '', url);
}
